import { BtnActions, ViewErrors } from '../Types';

export const estateApplicationErrors: ViewErrors = {
  TENANT_ALREADY_HAVE_AN_ACTIVE_APPLICATION_FOR_ESTATE_PROVIDED: {
    title: '¡Lo sentimos!',
    text: 'El usuario ya tiene una applicación en curso para este inmueble',
    btnText: 'Retomar Aplicación',
    btnAction: BtnActions.GO_NEXT,
  },
  DEFAULT: {
    title: 'Tuvimos un error inesperado',
    text: 'Algo ocurrió al intentar procesar tu información. Por favor intenta de nuevo.',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  }
};

export const addCotenantToEstateApplicationErrors: ViewErrors = {
  ERROR_COTENANT_ALREADY_EXISTS_IN_ESTATE_APPLICATION: {
    title: 'Ya habías aplicado por este inmueble ',
    text: 'Aplicaste como coarrendatario, pero por ahora solo debes esperar el resultado de la aplicación.',
    btnText: 'Terminar aplicación',
    btnAction: BtnActions.GO_NEXT,
  },
  ERROR_ESTATE_APPLICATION_IS_NOT_IN_STAGE_TO_ADD_COTENANT: {
    title: 'Esta aplicación no necesita un coarrendatario',
    text: 'En este caso, el tomador no necesita a nadie más para aprobar. ¡Lo sentimos!',
    btnText: 'Aceptar',
    btnAction: BtnActions.GO_HOME,
  },
  ERROR_COTENANT_IS_SAME_AS_TENANT: {
    title: 'Necesitas a otra persona para aplicar.',
    text: 'Tu coarrendatario debe ser otra persona distinta a ti, para poder obtener los ingresos que te faltan para aprobar.',
    btnText: 'Volver a Aptuno',
    btnAction: BtnActions.GO_HOME,
  },
  ERROR_ESTATE_APPLICATION_NOT_FOUND: {
    title: 'No encontramos la aplicación del tomador',
    text: 'Es posible que haya sido eliminada o cancelada.',
    btnText: 'Volver a Aptuno',
    btnAction: BtnActions.GO_HOME,
  },
  ERROR_MAX_COTENANTS_REACHED: {
    title: 'No podemos agregar más coarrendatarios',
    text: 'Si necesitas reemplazar alguno de los coarrendatarios actuales, contáctanos y te ayudaremos a hacerlo.',
    btnText: 'Aceptar',
    btnAction: BtnActions.GO_HOME,
  },
  DEFAULT: {
    title: 'Tuvimos un error inesperado',
    text: 'Algo ocurrió al intentar procesar tu información. Por favor intenta de nuevo.',
    btnText: 'Aceptar',
    btnAction: BtnActions.KEEP_ON_PAGE,
  }
};
